import styled from "styled-components";
import { TransparentCollapse } from "../TransparentCollapse";
import { Button } from "antd";

export const StyledProjectWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: #ffffff;
  padding: 24px;
`;

export const StyledProjectTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;

  & .ant-typography {
    margin: 0;
  }
`;
export const StyledTransparentCollapse = styled(TransparentCollapse)`

  .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding:24px 0;
  }

  .ant-collapse-item-active {
    background-color: #ffff;
  }
`;

export const StyledCardButton = styled(Button)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px 20px;
  gap: 4px;

  width: 177px;
  height: 32px;
`;